export default process.env.REACT_APP_API_LAMBDA_URL;
